import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type TUpdateBudgetDocumentSection = {
    sectionId: string;
    params: {
        session_title?: string;
        type?: string;
        content?: string;
        position?: number;
    };
};

export type TUpdateDocumentByIdResponse = {
    data: any;
};

export default async ({ sectionId, params }: TUpdateBudgetDocumentSection) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/session/${sectionId}`,
        method: "put",
        headers: { auth: true },
        body: params,
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TUpdateDocumentByIdResponse>({
        body,
        statusCode,
    });
};
